import { generatePath } from 'react-router-dom';

// todo: support nested routes
export const routes = {
  root: '/',
  resetPasswordRoute: 'reset-password',
  setNewPassword: 'set-password/:token',

  dashboard: {
    root: '/dashboard/*',
    unassigned: 'unassigned',
    assigned: 'assigned',
    history: 'history',
    visits: 'visits',
    myVisits: 'my-visits',
    liveVisits: 'live-visits',
    liveVisitsHistory: 'live-history',
  },

  patients: {
    root: '/patients',
  },

  messages: 'messages',

  examination: '/examinations/:id',

  visit: '/visit/:id',
};

export const getSetNewPasswordRoute = (token: string) =>
  generatePath(routes.setNewPassword, { token });

export const getDashboardChildRoute = (childRoute: string) =>
  generatePath(routes.dashboard.root, { '*': childRoute });

export const getPatientsChildRoute = (childRoute: string) =>
  generatePath(`${routes.patients.root}/*`, { '*': childRoute });

export const getExaminationRoute = (id: string | number) =>
  generatePath(routes.examination, { id: `${id}` });

export const getVisitRoute = (id: string | number) =>
  generatePath(routes.visit, { id: `${id}` });

export const getLiveVisitRoute = (id: string | number) =>
  generatePath(routes.visit, { id: `${id}` });

export const getPreviousLiveVisitsRoute = (childRoute: string) =>
  generatePath(routes.dashboard.liveVisitsHistory, { '*': childRoute });

export const getVisitsRoute = (childRoute: string) =>
  generatePath(routes.dashboard.visits, { '*': childRoute });

// export const getVisitsRoute = () => generatePath(routes.dashboard.visits);

// export const getPreviousVisitsRoute = (childRoute: string) =>
//   generatePath(routes.dashboard.liveVisitsHistory, { '*': childRoute });
